import React, { useState, useEffect } from "react";

export const CartActions = ({ show_cart }) => {
  const checkoutButtonText = `CHECKOUT`;
  const cartButtonText = 'VIEW BAG';

  return (
    <div className={"minicart__actions"}>
      <form id="checkout" action="/checkout" method="post" className=""></form>
      <form id="cart" action="/cart" method="get" className=""></form>

      <div className={"minicart__buttons"}>
        <button
          className="button button-primary"
          type="submit"
          name="checkout"
          form="checkout"
        >
          {checkoutButtonText}
        </button>
        {show_cart && (
          <button className="minicart__buttons--cart button button-primary" type="submit" form={"cart"}>
              {cartButtonText}
          </button>
        )}
      </div>
    </div>
  );
};
